// A targeting source is a page, not an account. Share the id with its same-origin scene
// frame, but not sessionStorage (new/duplicated tabs can inherit that storage).
const clientKey = '__ft3dTargetingPreviewClientId';

export function ft3dTargetingPreviewClientId(): string {
  let host = window as unknown as Record<string, unknown>;
  try {
    if (window.top?.location.origin === window.location.origin) host = window.top as unknown as Record<string, unknown>;
  } catch { /* standalone/cross-origin hosts keep their own identity */ }
  if (typeof host[clientKey] !== 'string') host[clientKey] = crypto.randomUUID().toLowerCase();
  return host[clientKey] as string;
}

export function targetingPreviewStreamKey(data: { from_user_id?: unknown; from_client_id?: unknown; encounter_id?: unknown }): string {
  return [data.encounter_id, data.from_user_id, data.from_client_id ?? 'legacy'].map(v => String(v ?? '').toUpperCase()).join(':');
}

export function isOwnTargetingPreview(data: { from_user_id?: unknown; from_client_id?: unknown }, userId: unknown): boolean {
  if (String(data.from_user_id ?? '').toUpperCase() !== String(userId ?? '').toUpperCase()) return false;
  // Old senders have no page identity; retain their historical echo handling.
  return !data.from_client_id || String(data.from_client_id).toLowerCase() === ft3dTargetingPreviewClientId();
}
